import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface ClearingGradingProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const ClearingGrading: React.FC<ClearingGradingProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [clearingGrading, set_clearingGrading] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Site Work']?.['Clearing & Grading'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Site Work': { ...b.values?.['Site Work'], 'Clearing & Grading': v } } })
    );
    const label = 'Clearing and Grading';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(clearingGrading)}
                />
            ) : (
                <MoneyBox
                    id={'clearingGrading'}
                    allowNegative={false}
                    value={clearingGrading}
                    onChange={(value) => set_clearingGrading(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
